function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBalloon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 511.999 511.999",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB547"
    },
    d: "M255.999,8.106L255.999,8.106c-87.001,0-157.529,70.528-157.529,157.529l0,0 c0,55.141,21.391,108.132,59.672,147.819l25.11,26.034c6.236,6.464,14.831,10.116,23.813,10.116h97.875 c8.982,0,17.578-3.652,23.814-10.117l25.105-26.03c38.279-39.689,59.669-92.68,59.669-147.821l0,0 C413.528,78.634,343,8.106,255.999,8.106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6361"
    },
    d: "M255.999,8.106L255.999,8.106L255.999,8.106c-90.665,90.664-101.733,233.874-26.075,337.392 l3.001,4.106h46.149l3.001-4.106C357.732,241.98,346.663,98.769,255.999,8.106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#65513C"
    },
    d: "M193.006,442.435v50.641c0,5.975,5.41,10.818,12.085,10.818h101.818 c6.674,0,12.085-4.844,12.085-10.818v-50.641H193.006z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      enableBackground: "new"
    },
    d: "M318.992,451.844v-9.409H193.006v50.641 c0,5.975,5.41,10.818,12.085,10.818h101.818c6.385,0,11.601-4.436,12.042-10.053c-0.405,0.037-0.817,0.056-1.234,0.056H215.898 c-6.674,0-12.085-4.844-12.085-10.818v-31.236H318.992z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0",
    style: {
      fill: "#B07C57"
    },
    d: "M322.872,407.914H189.126c-6.859,0-12.42,5.56-12.42,12.42v9.681 c0,6.859,5.56,12.42,12.42,12.42h133.747c6.859,0,12.42-5.56,12.42-12.42v-9.681C335.293,413.474,329.733,407.914,322.872,407.914z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0_1_",
    style: {
      fill: "#B07C57"
    },
    d: "M322.872,407.914H189.126c-6.859,0-12.42,5.56-12.42,12.42v9.681 c0,6.859,5.56,12.42,12.42,12.42h133.747c6.859,0,12.42-5.56,12.42-12.42v-9.681C335.293,413.474,329.733,407.914,322.872,407.914z "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      enableBackground: "new"
    },
    d: "M330.437,435.95H196.691c-6.859,0-12.42-5.56-12.42-12.42v-9.681 c0-1.938,0.457-3.765,1.248-5.399c-5.1,1.545-8.813,6.279-8.813,11.884v9.681c0,6.859,5.56,12.42,12.42,12.42h133.747 c4.922,0,9.161-2.869,11.172-7.021C332.903,435.76,331.693,435.95,330.437,435.95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9E0A4"
    },
    d: "M243.035,465.698c0,7.829-6.346,14.175-14.175,14.175c-7.829,0-14.175-6.346-14.175-14.175 s6.346-23.263,14.175-23.263C236.689,442.435,243.035,457.869,243.035,465.698z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      enableBackground: "new"
    },
    d: "M232.913,475.009c-7.829,0-14.175-6.346-14.175-14.175 c0-4.415,2.019-11.248,5.183-16.369c-5.393,4.447-9.236,15.14-9.236,21.232c0,7.829,6.346,14.175,14.175,14.175 c5.524,0,10.297-3.167,12.637-7.777C239.113,473.917,236.145,475.009,232.913,475.009z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9E0A4"
    },
    d: "M268.962,465.698c0,7.829,6.346,14.175,14.175,14.175s14.175-6.346,14.175-14.175 s-6.346-23.263-14.175-23.263S268.962,457.869,268.962,465.698z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      enableBackground: "new"
    },
    d: "M287.19,475.009c-7.829,0-14.175-6.346-14.175-14.175 c0-4.415,2.019-11.248,5.183-16.369c-5.393,4.447-9.236,15.14-9.236,21.232c0,7.829,6.346,14.175,14.175,14.175 c5.524,0,10.297-3.167,12.637-7.777C293.391,473.917,290.422,475.009,287.19,475.009z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M328.718,333.792h-69.271c-32.096,0-62.812-13.049-85.094-36.15l0,0 c-38.28-39.687-59.671-92.678-59.671-147.818l0,0c0-40.138,15.019-76.761,39.734-104.578 C120.204,74.143,98.47,117.348,98.47,165.636v0.001c0,55.141,21.391,108.131,59.672,147.819l25.11,26.034 c6.236,6.464,14.831,10.116,23.813,10.116h97.875c8.982,0,17.578-3.652,23.814-10.117l6.044-6.267 C332.806,333.592,330.773,333.792,328.718,333.792z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1E252B"
    },
    d: "M304.94,357.708c11.122,0,21.928-4.591,29.649-12.596l25.105-26.03 c39.943-41.414,61.941-95.911,61.941-153.447C421.634,74.303,347.33,0,255.999,0S90.364,74.303,90.364,165.635 c0,57.538,21.999,112.033,61.943,153.446l25.111,26.034c7.72,8.003,18.526,12.593,29.647,12.593h1.888v42.099h-19.828 c-11.318,0-20.525,9.208-20.525,20.525v9.681c0,9.869,7.003,18.129,16.301,20.083v42.978c0,10.435,9.057,18.924,20.19,18.924 h101.818c11.133,0,20.19-8.488,20.19-18.924v-42.978c9.297-1.954,16.3-10.214,16.3-20.083v-9.681 c0-11.319-9.208-20.525-20.525-20.525h-19.828v-42.099H304.94z M310.887,493.076c0,1.284-1.634,2.713-3.979,2.713H205.089 c-2.344,0-3.979-1.429-3.979-2.713V450.54h109.775v42.536H310.887z M322.872,416.019c2.379,0,4.314,1.936,4.314,4.314v9.681 c0,2.379-1.936,4.314-4.314,4.314H189.126c-2.379,0-4.314-1.936-4.314-4.314v-9.681c0-2.379,1.936-4.314,4.314-4.314H322.872z  M225.164,399.808v-42.099h61.669v42.099H225.164z M207.065,341.497c-6.745,0-13.297-2.783-17.979-7.637l-25.11-26.034 c-37.015-38.376-57.399-88.873-57.399-142.191c-0.001-82.393,67.03-149.424,149.423-149.424s149.424,67.031,149.424,149.424 c0,53.317-20.384,103.817-57.397,142.194l-25.105,26.03c-4.682,4.854-11.235,7.638-17.98,7.638L207.065,341.497L207.065,341.497z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalloon);
export default __webpack_public_path__ + "static/media/balloon.149c2c5ef7ba1f79225a3538015c093e.svg";
export { ForwardRef as ReactComponent };